export const NOTIFICATIONS_LOAD = 'NOTIFICATIONS_LOAD';
export const NOTIFICATIONS_RELOAD = 'NOTIFICATIONS_RELOAD';
export const NOTIFICATIONS_SAVE = 'NOTIFICATIONS_SAVE';
export const NOTIFICATIONS_SAVE_ONE = 'NOTIFICATIONS_SAVE_ONE';
export const NOTIFICATIONS_CHANGE_STATE = 'NOTIFICATIONS_CHANGE_STATE';
export const NOTIFICATIONS_SSE_ERROR = 'NOTIFICATIONS_SSE_ERROR'